module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"toAccount":"В личный кабинет"}}')
  delete Component.options._Ctor
}
